import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  ListGroup,
  ListGroupItem,
} from 'react-bootstrap';

import './style.css';

const propTypes = exact({
  list: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
});


class ClickableList extends Component {
  render() {
    const { list } = this.props;
    return (
      <React.Fragment>
        <ListGroup className="scrollable-list">
          {list.map((item) => {
            return (
              <ListGroupItem
                key={item.id}
                onClick={() => {
                  return this.props.onSelect(item);
                }}
              >
                {item.name}
              </ListGroupItem>
            );
          })}
        </ListGroup>
      </React.Fragment>
    );
  }
}


ClickableList.propTypes = propTypes;


export default ClickableList;
